"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultGuidesDistricts = void 0;
exports.defaultGuidesDistricts = {
    imageUrl: 'https://dev.okay.com/CommonContent/DistrictGuideImages/Kowloon.jpg',
    districts: [{
            districtId: 40,
            districtName: 'Diamond Hill',
            url: 'https://devnew.okay.com/en-US/district/diamond-hill/40',
        }, {
            districtId: 41,
            districtName: 'Ho Man Tin',
            url: 'https://devnew.okay.com/en-US/district/ho-man-tin/41',
        }, {
            districtId: 42,
            districtName: 'Hung Hom',
            url: 'https://devnew.okay.com/en-US/district/hung-hom/42',
        }, {
            districtId: 46,
            districtName: 'Kowloon City',
            url: 'https://devnew.okay.com/en-US/district/kowloon-city/46',
        }, {
            districtId: 47,
            districtName: 'Kowloon Tong',
            url: 'https://devnew.okay.com/en-US/district/kowloon-tong/47',
        }, {
            districtId: 49,
            districtName: 'Lai Chi Kok',
            url: 'https://devnew.okay.com/en-US/district/lai-chi-kok/49',
        }, {
            districtId: 52,
            districtName: 'Mong Kok',
            url: 'https://devnew.okay.com/en-US/district/mong-kok/52',
        }, {
            districtId: 58,
            districtName: 'Shek Kip Mei',
            url: 'https://devnew.okay.com/en-US/district/shek-kip-mei/58',
        }, {
            districtId: 61,
            districtName: 'Tsim Sha Tsui',
            url: 'https://devnew.okay.com/en-US/district/tsim-sha-tsui/61',
        }, {
            districtId: 65,
            districtName: 'Yau Ma Tei',
            url: 'https://devnew.okay.com/en-US/district/yau-ma-tei/65',
        }, {
            districtId: 103,
            districtName: 'Olympic Station',
            url: 'https://devnew.okay.com/en-US/district/olympic-station/103',
        }, {
            districtId: 104,
            districtName: 'Kowloon Station',
            url: 'https://devnew.okay.com/en-US/district/kowloon-station/104',
        },
    ],
};
